import styled from "styled-components";

export const ErrorBox = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 8px;
  padding: 16px 0;
`;

export const ErrorText = styled.span`
  font-size: large;
  color: red;
`;
